import { StyleSheet } from 'react-native-unistyles';
import Box from '../UI/Box';

type DepthListIndentProps = {
  columns: boolean[];
};

function DepthListIndent({ columns }: DepthListIndentProps) {
  if (!columns.length) {
    return <Box style={style.indentEmpty} />;
  }

  const parts = [];
  const lastIndex = columns.length - 1;

  for (let col = 0; col < columns.length; col += 1) {
    const isLast = col === lastIndex;
    const continues = columns[col];

    parts.push(
      <Box key={`indent-${columns.length}-${col}`} style={style.indentColumn}>
        {!isLast ? (
          continues ? (
            <Box style={[style.indentLine, style.indentLineFull]} />
          ) : null
        ) : (
          <Box
            style={[
              style.indentLine,
              continues ? style.indentLineFull : style.indentLineHalf,
            ]}
          />
        )}
        {isLast ? <Box style={style.indentElbow} /> : null}
      </Box>,
    );
  }

  return (
    <Box direction="horizontal" style={style.indentContainer}>
      {parts}
    </Box>
  );
}

export default DepthListIndent;

const style = StyleSheet.create((theme) => {
  const lineThickness = theme.size(1);
  const lineColor = theme.colors.borderMuted;
  const indentStep = theme.size(4);
  const elbowLength = indentStep * 0.8;
  const rowHeight = theme.size(12);
  const overlap = Math.max(theme.size(0.75), lineThickness * 2);

  return {
    indentEmpty: {
      width: 0,
    },
    indentContainer: {
      alignItems: 'stretch',
      marginRight: theme.size(1.25),
      height: rowHeight,
    },
    indentColumn: {
      width: indentStep,
      height: rowHeight,
      marginLeft: theme.size(2.5),
    },
    indentLine: {
      position: 'absolute',
      left: '50%',
      width: lineThickness,
      transform: [{ translateX: -lineThickness / 2 }],
      borderRadius: 999,
      backgroundColor: lineColor,
    },
    indentLineFull: {
      top: -overlap,
      bottom: -overlap,
    },
    indentLineHalf: {
      top: -overlap + 2,
      height: rowHeight / 2 + overlap,
    },
    indentElbow: {
      position: 'absolute',
      top: rowHeight / 2,
      left: '50%',
      height: lineThickness,
      width: elbowLength + theme.size(0.75),
      transform: [{ translateY: -lineThickness / 2 }],
      borderRadius: theme.size(0.25),
      backgroundColor: lineColor,
    },
  };
});
